import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import { connect } from "react-redux";
import * as printActions from "store/actions/print/printActions";
import * as exposureSelectors from "store/selectors/input/exposure/exposureSelectors";

const CurrentExposuresDialog = ({ open, onClose, ...props }) => {
  const exposureKeys = (props.exposures ?? []).map((exposure) => exposure.key);
  const selectedExposureKeys = props.currentExposuresKeys ?? exposureKeys ?? [];

  const toggleExposure = (key) => {
    const base = props.currentExposuresKeys ?? exposureKeys ?? [];
    const next = base.includes(key)
      ? base.filter((item) => item !== key)
      : [...base, key];
    props.setCurrentExposuresKeys(next);
  };

  const selectAll = () => {
    props.setCurrentExposuresKeys(exposureKeys);
  };

  const clearAll = () => {
    props.setCurrentExposuresKeys([]);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{"Current Exposures"}</DialogTitle>
      <DialogContent sx={{ maxHeight: "60vh", paddingBottom: 0 }}>
        <FormGroup>
          <FormLabel sx={{ marginBottom: "8px" }}>
            {"Select exposures to display"}
          </FormLabel>
          <Box sx={{ display: "flex", gap: 1, marginBottom: "12px" }}>
            <Button variant={"contained"} size={"small"} onClick={selectAll}>
              {"Show all"}
            </Button>
            <Button
              variant={"contained"}
              size={"small"}
              color={"secondary"}
              onClick={clearAll}
            >
              {"Hide all"}
            </Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              columnGap: 2,
              rowGap: 0,
              paddingBottom: 0,
            }}
          >
            {(props.exposures ?? []).map((exposure) => (
              <FormControlLabel
                key={exposure.key}
                control={
                  <Checkbox
                    checked={selectedExposureKeys.includes(exposure.key)}
                    onChange={() => toggleExposure(exposure.key)}
                  />
                }
                label={exposure.name ?? exposure.key}
                sx={{ marginRight: 0, marginTop: 0, marginBottom: 0 }}
              />
            ))}
          </Box>
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button variant={"contained"} color={"primary"} onClick={onClose}>
          {"Accept"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    currentExposuresKeys: state.print.currentExposuresKeys,
    exposures: exposureSelectors.getExposureList(state),
  };
};

const mapDispatchToProps = {
  setCurrentExposuresKeys: printActions.setCurrentExposuresKeys,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentExposuresDialog);
